import { CustomError } from "src/app/shared/services/errors/custom-error";


export class NotAllowToCreateExtraOrderAfter23thError extends CustomError {
  constructor() {
    super('Sonderbestellungen können nur vor dem 23. des Monats erstellt werden #TRANSLATE')
    Object.setPrototypeOf(this, NotAllowToCreateExtraOrderAfter23thError.prototype);
  }
}
